<template>
  <div>
    <a-card title="任务创建">
      <a-spin :spinning="loading">
        <!-- 表单部分 -->
        <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
          <a-row>
            <a-col :span="8" style="width: 300px;">
              <a-form-model-item prop="start_date" label="任务开始日期">
                <a-date-picker v-model="form.start_date" valueFormat="YYYY-MM-DD" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" style="width: 300px;">
              <a-form-model-item prop="end_date" label="任务结束日期">
                <a-date-picker v-model="form.end_date" valueFormat="YYYY-MM-DD" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" style="width: 300px;">
              <a-form-model-item prop="supplier" label="所在省">
                <a-select v-model="now_city.province" style="width: 100%" @change="change_city">
                  <a-select-option v-for="item in province_Items" :key="item" :value="item">{{ item }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8" style="width: 300px;">
              <a-form-model-item prop="warehouse" label="所在市">
                <a-select v-model="now_city.city" style="width: 100%" @change="change_district">
                  <a-select-option v-for="item in city_Items" :key="item" :value="item">{{ item}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8" style="width: 300px;">
              <a-form-model-item prop="handler" label="所在区/县">
                <a-select v-model="now_city.district" style="width: 100%; margin-right: 8px;" @change="change_map">
                  <a-select-option v-for="item in distirct_Items" :key="item" :value="item">{{ item}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-button
                @click="handleLocation"
                style="flex-shrink: 0; border: none; background: transparent; padding: 0; width: 32px; height: 32px; margin-left: 32px"
                class="location-btn"
            >
              <img src="@/assets/place.png" style="width: 34px; height: 34px;" alt="定位" />
            </a-button>

            <a-col :span="24" style="display: flex; justify-content: flex-end; padding: 15px 0 10px;">
              <div style="display: flex; flex-direction: column; gap: 10px; width: 160px;">
                <a-button type="primary" @click="openMaterialModal">
                  添加地点
                </a-button>
                <a-button type="primary" @click="selectAndUploadImage">
                  <a-icon type="upload" />
                  上传本地图片
                </a-button>
              </div>
            </a-col>
          </a-row>
        </a-form-model>

        <a-divider orientation="left">详细信息</a-divider>
        <div>
          <a-row :gutter="16">
            <a-col :span="24" style="position: relative; padding-bottom: 20px;">
              <!-- 隐藏的文件选择框 -->
              <input
                  type="file"
                  id="fileInput"
                  accept="image/*"
                  style="display: none"
                  @change="handleFileSelect"
              >

              <!-- 图片预览区域：横向排列（核心修改） -->
              <div class="camera_outer" style="margin-top: 10px; width: calc(100% - 150px);">
                <canvas style="display:none;" id="canvasCamera" :width="videoWidth" :height="videoHeight"></canvas>
                <!-- 横向排列样式：flex布局 + 自动换行 -->
                <div v-if="imgSrc.length > 0" class="img_bg_camera" style="display: flex; gap: 10px; flex-wrap: wrap; padding: 10px; min-height: 150px;">
                  <div v-for="(img, index) in imgSrc" :key="index" class="tx_img_container">
                    <img :src="img" alt="上传的图片" class="tx_img" />
                  </div>
                </div>
              </div>
            </a-col>

            <!-- 表格区域 -->
            <div style="margin-top: 16px;">
              <a-table rowKey="name" size="middle" :columns="columns" :data-source="form_data">
                <div slot="action" slot-scope="value, item, index">
                  <a-button-group v-if="!item.isTotal" size="small">
                    <a-button type="danger" @click="remove_from_data(index)">移除</a-button>
                  </a-button-group>
                </div>
                <div slot="map_data" slot-scope="value, item, index">
                  <Map :data="item"></Map>
                </div>
              </a-table>
            </div>
          </a-row>
        </div>

        <a-divider orientation="left">任务信息</a-divider>
        <div>
          <a-row :gutter="16">
            <a-col :span="4">
              <a-form-model-item
                  prop="other_amount"
                  label="备注"
                  :label-col="{ span: 24 }"
                  :wrapper-col="{ span: 24 }"
              >
                <a-input v-model="form.beizhu" />
              </a-form-model-item>
            </a-col>
            <a-col :span="4">
              <a-form-model-item label="发布者" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
                <a-input v-model="form.person" :disabled="true" style="width: 100%;" />
              </a-form-model-item>
            </a-col>
            <a-col :span="4">
              <a-form-model-item label="是否完成" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
                <a-input v-model="form.is_finish" :disabled="true" style="width: 100%;" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
      </a-spin>

      <!-- 创建按钮 -->
      <div style="margin-top: 32px;">
        <a-popconfirm title="确定创建吗?" @confirm="create">
          <a-button type="primary" :loading="loading">创建</a-button>
        </a-popconfirm>
      </div>
    </a-card>

    <!-- 地图组件 -->
    <Mymap
        v-model="add_task"
        :form="add_task_form"
        :userlist="userlist"
        :position="now_position"
        :city="now_city"
        :is_change_city="is_change_city"
        @confirm="confirm"
    />
  </div>
</template>

<script>
import { userlist_name, push_task, photo_save } from '@/api/task'
import AMapLoader from "@amap/amap-jsapi-loader";
import { get_province, get_city, get_district } from "@/views/task/city";
import axios from "axios";
import request from "@/utils/request";
import router from "@/router";

export default {
  components: {
    Mymap: () => import("@/components/map/map_choice"),
    Map: () => import("@/components/map/map"),
  },
  data() {
    return {
      videoWidth: 250,
      videoHeight: 350,
      imgSrc: [], // 存储上传的图片URL
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      openVideo: false,
      is_change_city: false,
      now_city: {
        province: '',
        city: '',
        district: ''
      }, // 初始化为空
      now_position: {},
      userlist: [{ username: 'admin', id: 0 }, { username: '谭福华', id: 2 }, { username: '齐辛格', id: 3 }],
      description: "新增",
      province_Items: [],
      city_Items: [],
      distirct_Items: [],
      accountsItems: [],
      add_task: false,
      add_task_form: {
        cnt: 0,
        person: '',
        name: '',
        beizhu: '',
        all_marker: [],
        all_line: [],
        all_distance: [],
        photo: [],
        collection_method: ''
      },
      loading: false, // 初始为false，因为不需要加载定位
      model: {},
      form: {},
      rules: {
        start_date: [{ required: true, message: "请输入开始日期", trigger: "change" }],
        end_date: [{ required: true, message: "请选择结束日期", trigger: "change" }],
      },
      columns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          width: 45,
          customRender: (value, item, index) => {
            return item.isTotal ? "合计" : index + 1;
          },
        },
        {
          title: "名称",
          dataIndex: "name",
          key: "name",
          width: 50,
        },
        {
          title: "检测范围",
          dataIndex: "map_data",
          key: "map_data",
          width: 200,
          scopedSlots: { customRender: "map_data" },
        },
        {
          title: "备注",
          dataIndex: "beizhu",
          key: "beizhu",
          width: 130,
        },
        {
          title: "拍照次数",
          dataIndex: "cnt",
          key: "cnt",
          width: 80
        },
        {
          title: "检测人",
          dataIndex: "person",
          key: "person",
          width: 100,
        },
        {
          title: "操作",
          dataIndex: "action",
          key: "action",
          width: 80,
          scopedSlots: { customRender: "action" },
        },
      ],
      form_data: []
    };
  },
  methods: {
    // 触发文件选择
    selectAndUploadImage() {
      document.getElementById('fileInput').click();
    },

    // 处理文件选择：显示预览并自动上传
    handleFileSelect(e) {
      const file = e.target.files[0]; // 只取第一个文件（单张限制）
      if (!file) return;

      if (!file.type.startsWith('image/')) {
        this.$message.error('请选择图片文件');
        e.target.value = ''; // 清空输入，允许重新选择
        return;
      }

      // 生成临时预览图
      const reader = new FileReader();
      reader.onload = (event) => {
        const tempSrc = event.target.result;
        this.imgSrc.push(tempSrc); // 先添加临时预览

        // 自动调用上传接口
        this.uploadImage(file, tempSrc);
      };
      reader.readAsDataURL(file);

      // 清空输入，允许重复选择同一文件
      e.target.value = '';
    },

    // 上传图片到服务器
    uploadImage(file, tempSrc) {
      const formData = new FormData();
      formData.append('image', file);

      photo_save(formData)
          .then((res) => {
            if (res.data.code === 0) {
              // 上传成功：用服务器URL替换临时预览
              const tempIndex = this.imgSrc.indexOf(tempSrc);
              if (tempIndex !== -1) {
                this.imgSrc.splice(tempIndex, 1, res.data.data);
              }
              // 更新拍照数量
              this.add_task_form.cnt = this.imgSrc.length;
              this.$message.success(`第${this.imgSrc.length}张图片上传成功`);
            } else {
              // 上传失败：移除临时预览
              this.removeFailedImage(tempSrc);
              this.$message.error('上传失败：' + res.data.msg);
            }
          })
          .catch((err) => {
            console.error('上传出错', err);
            // 网络错误：移除临时预览
            this.removeFailedImage(tempSrc);
            this.$message.error('上传失败，请重试');
          });
    },

    // 移除上传失败的临时图片
    removeFailedImage(tempSrc) {
      const tempIndex = this.imgSrc.indexOf(tempSrc);
      if (tempIndex !== -1) {
        this.imgSrc.splice(tempIndex, 1);
        // 更新拍照数量
        this.add_task_form.cnt = this.imgSrc.length;
      }
    },

    // 初始化地图并获取位置信息
    init_map() {
      AMapLoader.load({
        key: "94c008487c6ac7665d114c61eafe5cd1",
        version: "2.0",
        plugins: [],
      })
          .then((AMap) => {
            this.AMap = AMap;
            this.getloc();
          })
          .catch((e) => {
            console.log(e);
            this.$message.error('地图加载失败');
          });
    },

    getloc() {
      var that = this;
      AMap.plugin('AMap.Geolocation', function () {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          timeout: 10000,
          offset: [10, 20],
          zoomToAccuracy: true,
          position: 'RB',
          needAddress: true
        })

        geolocation.getCurrentPosition(function (status, result) {
          if (status === 'complete') {
            onComplete(result)
          } else {
            onError(result)
          }
        });

        function onComplete(data) {
          if (data.code === 0) {
            that.now_position = data.position;
            that.now_city = data.addressComponent;
            // 更新省市选择框的值
            that.change_province_with_location();
            that.$message.success('定位成功');
          } else {
            that.$message.error(data.message);
          }
        }

        function onError(data) {
          console.log('定位出错');
          console.log(data);
          that.$message.error('定位失败，请手动选择位置');
        }
      })
    },

    // 根据定位结果设置省市信息
    change_province_with_location() {
      this.province_Items = get_province();

      // 如果定位到的省份在列表中，则选中定位的省份
      if (this.now_city.province && this.province_Items.includes(this.now_city.province)) {
        // 省份使用定位结果
        this.change_city_with_location();
      } else {
        // 如果定位的省份不在列表中，使用第一个省份
        this.now_city.province = this.province_Items[0];
        this.change_city();
      }
    },

    // 根据定位结果设置城市信息
    change_city_with_location() {
      this.city_Items = get_city(this.now_city.province);

      // 如果定位到的城市在列表中，则选中定位的城市
      if (this.now_city.city && this.city_Items.includes(this.now_city.city)) {
        // 城市使用定位结果
        this.change_district_with_location();
      } else {
        // 如果定位的城市不在列表中，使用第一个城市
        this.now_city.city = this.city_Items[0];
        this.change_district();
      }
    },

    // 根据定位结果设置区县信息
    change_district_with_location() {
      this.distirct_Items = get_district(this.now_city.province, this.now_city.city);

      // 如果定位到的区县在列表中，则选中定位的区县
      if (this.now_city.district && this.distirct_Items.includes(this.now_city.district)) {
        // 区县使用定位结果
      } else {
        // 如果定位的区县不在列表中，使用第一个区县
        this.now_city.district = this.distirct_Items[0];
      }
      this.is_change_city = true;
    },

    // 手动定位按钮点击事件
    handleLocation() {
      this.init_map();
    },

    initData() {
      // 初始化省市数据，设置默认值
      this.change_province();
      this.form.person = this.$store.state.user.username;
      this.form.is_finish = 'false';

      userlist_name({}).then((res) => {
        if (res.code === 0)
          this.userlist = res.data;
      });
    },

    change_map() {
      this.is_change_city = true;
    },

    change_district() {
      this.distirct_Items = get_district(this.now_city.province, this.now_city.city);
      if (this.distirct_Items.length > 0) {
        this.now_city.district = this.distirct_Items[0];
      }
      this.is_change_city = true;
    },

    change_city() {
      this.city_Items = get_city(this.now_city.province);
      if (this.city_Items.length > 0) {
        this.now_city.city = this.city_Items[0];
        this.change_district();
      }
    },

    change_province() {
      this.province_Items = get_province();
      if (this.province_Items.length > 0) {
        this.now_city.province = this.province_Items[0];
        this.change_city();
      }
    },

    openMaterialModal() {
      this.add_task_form.province = this.now_city.province;
      this.add_task_form.city = this.now_city.city;
      this.add_task_form.district = this.now_city.district;

      this.add_task = true;
    },

    confirm(e) {
      if (e) {
        this.add_task = false;
        this.add_task_form.photo = this.imgSrc;
        this.add_task_form.name = 'Task' + (this.form_data.length + 1).toString();

        this.add_task_form.province = this.now_city.province;
        this.add_task_form.city = this.now_city.city;
        this.add_task_form.district = this.now_city.district;

        this.form_data.push({ ...this.add_task_form });
        // 重置计数和图片列表
        this.add_task_form.cnt = 0;
        this.imgSrc = [];
      }
    },

    remove_from_data(e) {
      this.form_data.splice(e, 1);
      for (var i = 0; i < this.form_data.length; i++) {
        this.form_data[i].name = '任务' + (i + 1).toString();
      }
    },

    create() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.form_data.length === 0) {
            this.$message.warn('至少添加一个子任务');
            return;
          }
          var data = {
            form: { ...this.form },
            now_city: {
              province: this.now_city.province,
              city: this.now_city.city,
              district: this.now_city.district
            },
            task: [...this.form_data],
          }
          push_task(data).then((res) => {
            if (res.data.code === 0) {
              this.$message.success('上传成功！')
              this.$router.push("/page/task/create");
            }else {
              this.$message.error('上传失败：' + res.data.msg)
            }
          })
        }
      });
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style>
.location-btn {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.location-btn:hover {
  background: transparent !important;
  border: none !important;
}

.location-btn:focus {
  background: transparent !important;
  border: none !important;
}

.tx_img_container {
  width: 150px;
  height: 150px;
  overflow: hidden;
  border: 1px solid #ddd;
}

.tx_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
